import axios from 'axios';

const baseURL = `${process.env.NODE_ENV === 'local' ? 'http://localhost:80' : '/server'}`;

export default axios.create({
	baseURL,
	withCredentials: true,
});
